import "./App.css";
import { useEffect, useState } from "react";
import {
  Navbar,
  Container,
  Row,
  Card,
  Button,
} from "react-bootstrap";
import { useMoralis, useWeb3ExecuteFunction } from "react-moralis";
import Web3 from "web3";

const logo2 = require("./logo2.png");
const etherscanlogo = require("./etherscanlogo.png");
const opensealogo = require("./opensea.png");

const logo1 = require("./logo1.png");
const contrAddress = "0xeEa220089119A2766d33C187D65121040e6D426F";
const contrABI = require("./abi.json");
const alchemyKey =
  "https://eth-mainnet.alchemyapi.io/v2/FDDQ7fIaUUfRfkoXnE5B_k3bkwzJ_OIH";

const nfts = require("./nfts.gif");
function App() {
  const [isConnected, setIsConnected] = useState(false);
  const {
    authenticate,
    isAuthenticated,
    isAuthenticating,
    user,
    account,
    logout,
  } = useMoralis();
  const { Moralis } = useMoralis();
  const contractProcessor = useWeb3ExecuteFunction();
  const [totalSupply, setTotalSupply] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const mintPrice = 0.003;
  useEffect(() => {
    if (isAuthenticated) {
      console.log("User is authenticated");
      getTotalSupply()
    } else {
      console.log("User is not authenticated");
    }
  }, [isAuthenticated]);

  const login = async () => {
    if (!isAuthenticated) {
      await authenticate()
        .then(function (user) {
          console.log("logged in user:", user);
        })
        .catch(function (error) {
          console.log("error:", error);
        });
    }
  };

  const getTxParams = (returnABI=true) => {
    return {
        contractAddress: contrAddress,
        functionName: "mint",
        abi: returnABI ? contrABI : "....",
        params: {
          quantity: quantity,
        },
        msgValue: totalSupply > 500 ? Moralis.Units.ETH(quantity * mintPrice) : 0,
    }
  }

  const mint = async (quantity) => {
    const mintPrice = 0.003;
    await Moralis.enableWeb3();
    const allowance = await Moralis.executeFunction(getTxParams());
    console.log(allowance);
  };
 

  const getTotalSupply = async () => {
    try {
    if(isAuthenticated){
      await Moralis.enableWeb3()
      const totalSupply = await Moralis.executeFunction({
        contractAddress: contrAddress,
        functionName: "totalSupply",
        abi: contrABI,
      });
      let supply = Web3.utils.hexToNumberString(totalSupply);
      setTotalSupply(supply);
      console.log(totalSupply)
    }
  } catch (error) {
    console.log(error);
  }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <Navbar expand="lg" style={{ background: "white", color: "black" }}>
        <Container>
          <Navbar.Brand href="#home" className="text-white">
            <img
              src={logo1}
              width="150"
              height="60"
              className="d-inline-block align-top"
              alt="logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text>
              {/*Show etherscan logo with href*/}

            </Navbar.Text>
          </Navbar.Collapse>
        </Container>{" "}
      </Navbar>

      <Container>
        <Row>
          <div className="col-md-12">
            <div className="text-center">
              <h1>
                <img
                  src={logo2}
                  alt="logo"
                  style={{ height: "200px", width: "500px" }}
                />
              </h1>
            </div>
          </div>
        </Row>
        <Row style={{display:"flex",justifyContent:"center", marginBottom:"2%"}}>
        <a
                href="https://etherscan.io/address/0xeea220089119a2766d33c187d65121040e6d426f"
                target="_blank"
                rel="noopener noreferrer"
                style={{width:"5%"}}
              >
                <img
                  src={etherscanlogo}
                  alt="etherscan logo"
                  style={{ height: "30px", width: "30px" }}
                />
              </a>
              <a
                href="https://opensea.io/collection/canny-pixel-club"
                target="_blank"
                rel="noopener noreferrer"
                style={{width:"5%"}}

              >
                <img
                  src={opensealogo}
                  alt="etherscan logo"
                  style={{ height: "30px", width: "30px" }}
                />
              </a>
        </Row>
        <Row
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "10%",
          }}
        >
          <Card style={{ width: "40%", paddingTop: "12px" }}>
            <Card.Img variant="top" src={nfts} />

            <Card.Body>
              <Button
                variant="primary"
                onClick={async () => {
                  if (isAuthenticated) {
                    // get input from id "quantity"
                    const quantity = document.getElementById("quantity").value;
                    await mint(quantity);
                  } else {
                    login();
                  }
                }}
                style={{ height: "100%", width: "75%", borderRadius: "65px", background:"rgb(203,105,52)", borderColor:"transparent", fontWeight:"700", fontSize:"20px",letterSpacing:"1px"}}
              >
                {isAuthenticated ? "MINT" : "Connect Wallet"}
              </Button>
              {/*Input that only accepts #1-20*/}
              <input
                type="number"
                min="1"
                max="10"
                placeholder="1"
                id="quantity"
                style={{
                  height: "100%",
                  width: "20%",
                  marginLeft: "5%",
                  fontSize: "1.3rem",
                  borderRadius: "30px",
                  padding:"15px"
                }}
                onChange={e => setQuantity(e.target.value)}
              />
            </Card.Body>
            <Card.Body>
              <h2 className="text-center">
                {totalSupply > 500 ? (quantity * .003).toFixed(4) : 0} ether
              </h2>
              {totalSupply < 500 ? (
                <h6 className="text-center">
                    <bold>
                    First 500 are free
                    </bold>
                </h6>
              ) : (<></>)}
            </Card.Body>
            <Card.Body>
              <h3 className="text-center">
              Total Minted: {totalSupply} / 3000
              </h3>
            </Card.Body>
          </Card>
        </Row>
        <Row>
          <p className="text-center">
            <strong>
            Due to recent scams where websites will overcharge users, and for trasparency we will output the full transaction parameters here. 
            </strong>
          </p>
          <p className="text-center">
          {JSON.stringify(getTxParams(false))}
          </p>
        </Row>
        {/*Create a modal with a */}
      </Container>
    </div>
  );
}

export default App;
